import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { RoutesRoutingModule } from './routes-routing.module';

import { ContactComponent } from './components/contact/contact.component';
import { MethodsAnalytesComponent } from './components/methods-analytes/methods-analytes.component';
import { LoginComponent } from './components/login/login.component';
import { RegisterLabComponent } from './components/register-lab/register-lab.component';
import { UpdateUserComponent } from './components/update-user/update-user.component';
import { SearchLabsComponent } from './components/searchLabs/searchLabs.component';

const COMPONENTS = [
  ContactComponent,
  MethodsAnalytesComponent,
  SearchLabsComponent,
  LoginComponent,
  RegisterLabComponent,
  UpdateUserComponent
];
const COMPONENTS_DYNAMIC = [];

@NgModule({
    imports: [SharedModule, RoutesRoutingModule],
    declarations: [...COMPONENTS, ...COMPONENTS_DYNAMIC]
})
export class RoutesModule {}
